import { ReactNode } from "react";

import "./style.scss";

import Header from "../header/header.comp";

const HeaderLayout = ({
    children,
    subheader,
    footer,
    blurHeader = true,
    subheaderHeight = 46,
    footerHeight = 80
}: {
    children: ReactNode;
    subheader?: ReactNode;
    footer?: ReactNode;
    blurHeader?: boolean;
    subheaderHeight?: number;
    footerHeight?: number;
}) => {
    const headerHeight = 56;
    const bodyContentStyles = {
        paddingBottom: blurHeader || !footer ? 0 : footerHeight,
        paddingTop: blurHeader ? 0 : subheader ? headerHeight + subheaderHeight : headerHeight
    };

    return (
        <div className="header-layout">
            <header
                className="header-content"
                style={subheader ? { height: headerHeight + subheaderHeight } : {}}
            >
                <div className="header-container">
                    <Header />
                </div>
                {!!subheader && (
                    <div className="subheader-container" style={{ height: subheaderHeight }}>
                        {subheader}
                    </div>
                )}
            </header>
            <div
                className={`body-content${!blurHeader ? " body-content--padding" : ""}`}
                style={bodyContentStyles}
            >
                {children}
            </div>
            {!!footer && (
                <div className="footer-content" style={{ minHeight: footerHeight }}>
                    {footer}
                </div>
            )}
        </div>
    );
};

export default HeaderLayout;
